import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 135 108",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M134.18 91.39H0V107.31H134.18V91.39Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M24.18 45.24H17.87V74.86H0.0100098V0H17.87V29.14H24.34L45.8 0H67.8L38.8 36.52L70.24 74.86H47.8L24.18 45.24Z",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("path", {
      d: "M105.98 0C124.48 0 134.32 9.2 134.32 24C134.32 35.87 126.83 44.21 113.41 46.35L134.9 74.9H113.62L93.8902 46.9H91.2702V74.9H73.4102V0H105.98ZM91.2702 16.24V31.85H105.8C112.22 31.85 116.17 29.34 116.17 23.99C116.17 18.64 112.07 16.24 105.8 16.24H91.2702Z",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }